'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const TabularFileCompare = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Tabset = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 20px 0;

  .tab {
    padding: 10px 25px;
    border: 1px solid ${colors.secondary.lightGray3};
    border-radius: 5px 5px 0 0;
    margin-bottom: -1px;
    z-index: 1;
    &:not(.tab-active) {
      background-color: ${colors.secondary.lightGray1};
      color: ${colors.secondary.mediumGray};
      &:hover {
        color: ${colors.primary.black};
      }
    }
  }
  .tab-active {
    font-weight: bold;
    border-bottom: 1px solid ${colors.primary.white};
  }
  /* border-bottom: 1px solid ${colors.secondary.lightGray3}; */
`;
